import cfg from '@/fetch/config'

let config = {
  // 本地消息显示数量，会影响性能
  localMsglimit: 36,
  useDb: false
}

const env = cfg.NODE_ENV;

let appConfig = {
  //本地环境
  local_dev: {
    appkey: 'cc34e75324b841fe1b733ed65690421e' // rel
    // appkey: '63f9813a7ca29695b0f1b70fafcc067c', // dev
    // appkey: 'fa082728749bbd966489e72b04679e1c', // 生产
  },
  //开发环境
  development: {
    appkey: 'cc34e75324b841fe1b733ed65690421e',
    // appkey: 'fa082728749bbd966489e72b04679e1c',
  },
  //测试环境
  testing: {
    // appkey: 'cc34e75324b841fe1b733ed65690421e',
    appkey: '63f9813a7ca29695b0f1b70fafcc067c'
  },
  //生产环境
  production: {
    appkey: 'fa082728749bbd966489e72b04679e1c',
  },
}

config = Object.assign(config, appConfig[env])
console.log('IM对应的当前项目环境', env);
console.log('IM对应的初始化配置appkey', config.appkey);

export default config



// WEBPACK FOOTER //
// ./src/utils/im/config.js